<template>
    <div class="container">
        <b-modal
            :model-value="modalCrear"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.codigo }}</label>
                        <b-form-input
                            v-model="form.codigo"
                            type="number"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.tipoActivo }}</label>
                        <b-form-select
                            v-model="form.tipo_activo"
                            class="reset-input"
                        >
                            <option value=""> {{ labels.select }} </option>
                            <option
                                v-for="tipActiv in listaTypeAct"
                                :key="tipActiv.id"
                                :value="tipActiv.tipo_activo"
                            >
                                {{ tipActiv.descripcion }}
                            </option>
                        </b-form-select>

                        <div v-if="showListTipAct">
                            <div
                                v-for="caracteristica in caractActivo"
                                :key="caracteristica.id"
                                class="mb-3"
                            >
                                <label>
                                    {{
                                        caracteristica.descripcion
                                            .toLowerCase()
                                            .replace(/^./, c => c.toUpperCase())
                                    }}
                                </label>

                                <b-form-input
                                    v-model="listCaractAct[caracteristica.caracteristica]"
                                    type="text"
                                    class="reset-input"
                                />
                            </div>
                        </div>

                        <label>{{ labels.proveedor }}</label>
                        <b-form-select
                            v-model="form.proveedor"
                            class="reset-input"
                        >
                            <option value=""> {{ labels.select }} </option>
                            <option
                                v-for="tercero in listaTerceros"
                                :key="tercero.id"
                                :value="tercero.identificacion"
                            >
                                {{ tercero.nombre }}
                            </option>
                        </b-form-select>

                        <label>{{ labels.fechaCompra }}</label>
                        <b-form-input
                            v-model="form.fecha_compra"
                            type="date"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.valorCompra }}</label>
                        <b-form-input
                            v-model="form.valor_compra"
                            type="number"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.valorSalvamento }}</label>
                        <b-form-input
                            v-model="form.valor_salvamento"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="guardarActivo()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
    </div>
</template>

<script>

import TipoActivo from '../../services/TipoActivo' 
import Tercero from '../../services/Tercero' 
import Activo from '../../services/Activos' 
import TipoActivoCaracteristica from '../../services/TipoActivoCaracteristica' 

export default {
    name:'Crear',
    props:{
        modalCrear: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                codigo: "",
                tipo_activo: "",
                proveedor: "",
                fecha_compra: "",
                valor_compra: "",
                valor_salvamento: ""
            },
            listaTypeAct: [],
            listaTerceros: [],
            showListTipAct: false,
            caractActivo: [],
            listCaractAct: {}
        }
    },
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Crear activo",
                    codigo : "Código",
                    tipoActivo : 'Tipo activo',
                    proveedor : 'Proveedor',
                    fechaCompra : 'Fecha compra',
                    valorCompra : 'Valor compra',
                    valorSalvamento : 'Valor salvamento',
                    save : "Guardar",
                    close : "Cerrar",
                    select : "Seleccione...", 
                    formInfoTitle: "Datos del activo",
                    formInfoSubtitle: "Completa la información y guarda el nuevo activo."
                }
            }else{
                return {
                    title: "Create active",
                    codigo : "Code",
                    tipoActivo : 'Active type',
                    proveedor : 'Provider',
                    fechaCompra : 'Purchase date',
                    valorCompra : 'Purchase value',
                    valorSalvamento : 'Salvage value',
                    save : "Sava",
                    close : "Close",
                    select : "Select...", 
                    formInfoTitle: "Asset details",
                    formInfoSubtitle: "Complete the information and save the new asset."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.cleanInp()
            this.$emit('cierraModal',false) 
        },
        guardarActivo(){

            const listCaract = this.caractActivo.map(item => ({
                codCaracteristica: item.caracteristica,
                infoCaracterist: item.descripcion,
                caracteristica: this.listCaractAct[item.caracteristica] || ""
            }));

            const existeVacio = listCaract.some(item =>
                !item.caracteristica ||
                item.caracteristica.trim() === ""
            );

            if (existeVacio) {
                this.$toast.error("Característica(s) pendiente(s) por diligenciar");
                return;
            }

            if (
                !this.form.codigo ||
                !this.form.tipo_activo ||
                !this.form.proveedor ||
                !this.form.fecha_compra ||
                !this.form.valor_compra ||
                !this.form.valor_salvamento
            ) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }

            const info = {
                codActivo: this.form.codigo,
                tipo_activo: this.form.tipo_activo,
                proveedor: this.form.proveedor,
                fecha_compra: this.form.fecha_compra,
                valor_compra: this.form.valor_compra,
                valor_salvamento: this.form.valor_salvamento,
                idUser: this.$store.state.userId,
                caract_activo: listCaract
            }

            Activo.createActivo(info) 
            .then((res) => { 

                this.$toast.success(res.data.message) 
                this.$emit("creado");
                this.cierraModal();
            })
            .catch((error) => {
                if (error.response) {
                    this.$toast.error(error.response.data.message);
                } else {
                    console.error(error);
                    this.$toast.error("Ocurrió un error.");
                }
            }) 
        },
        cleanInp(){
            this.form = {
                codigo: "",
                tipo_activo: "",
                proveedor: "",
                fecha_compra: "",
                valor_compra: "",
                valor_salvamento: ""
            };

            this.listCaractAct = {};
            this.caractActivo = [];
            this.showListTipAct = false;
        }
    },
    mounted(){
        TipoActivo.getAllTipoActivo() 
        .then((res) => { 
            // console.log(res.data.listTipoActivo) 
            this.listaTypeAct = res.data.listTipoActivo 
            this.showListTipAct = true 
        })
        .catch((err) => { console.log(err) }) 

        Tercero.getAllTercero() 
        .then((res) => { 
            // console.log(res.data.listTercero); 
            this.listaTerceros = res.data.listTercero 
        })
    },
    watch: {
        "form.tipo_activo"(valNew) {

            if (!valNew) {
                this.caractActivo = [];
                return;
            }

            TipoActivoCaracteristica
            .getTipoActivoCaractByTipAct(valNew)
            .then((res) => {
                this.showListTipAct = true
                this.caractActivo = res.data.tipActCar;

                this.listCaractAct = {};

                this.caractActivo.forEach(item => {
                    this.listCaractAct[item.caracteristica] = "";
                });
            })
            .catch(console.error);
        }
    }
}
</script>

<style>

</style>
